import Modal from '@/components/base/Modal';

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  loading?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export default function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = 'Xóa',
  loading = false,
  onCancel,
  onConfirm,
}: ConfirmDialogProps) {
  return (
    <Modal open={open} onClose={onCancel} title={title} maxWidth="max-w-md">
      <p className="px-4 text-sm leading-relaxed text-foreground-600 sm:px-0">{message}</p>
      <div className="mt-6 flex items-center justify-end gap-3 px-4 sm:px-0">
        <button
          type="button"
          onClick={onCancel}
          className="min-w-[80px] whitespace-nowrap rounded-lg border border-background-300 bg-background-50 px-4 py-2.5 text-sm font-medium text-foreground-700 transition hover:bg-background-100 sm:py-2"
        >
          Hủy
        </button>
        <button
          type="button"
          onClick={onConfirm}
          disabled={loading}
          className="min-w-[80px] flex items-center justify-center gap-2 whitespace-nowrap rounded-lg bg-accent-500 px-4 py-2.5 text-sm font-semibold text-background-50 transition hover:bg-accent-600 disabled:cursor-not-allowed disabled:opacity-60 sm:py-2"
        >
          {loading && (
            <div className="h-4 w-4 animate-spin rounded-full border-2 border-background-50 border-t-transparent" />
          )}
          {confirmLabel}
        </button>
      </div>
    </Modal>
  );
}